<template>
    <div id="board">
        <div class="tile-row" v-for="(tileRow, index) in tileMap" :key="index">
            <board-tile v-for="(tile, innerIndex) in tileRow" :key="innerIndex" :tile-object="{...tile}">  </board-tile>
        </div>
    </div>
</template>

<script>
import BoardTile from './BoardTile.vue';

export default {
    components: { BoardTile },
    props: {
        tileMap: {
            type: Array,
            required: true
        }
    },
};
</script>

<style scoped>
#board{
    background-color: white;
    padding: 1px;
    margin-left: 30px;
    margin-right: 30px;
}
.tile-row{
    display: flex;
    flex-wrap: no-wrap;
}
</style>
